import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useGetAuth, useSetAuth } from '../hooks/useAuth';
import { privileged } from '../constants/config';
import AuthLinkError from './AuthLinkError';

export default function ValidateAuth() {
  const params = useParams();
  const navigate = useNavigate();
  const { isLoading, isError, data, error } = useGetAuth(params.token);

  useSetAuth(data);

  useEffect(() => {
    // Only navigate once a real auth payload is present; an error or an
    // unexpected body shape must not throw here or the page hangs silently.
    const attributes = data?.data?.data?.attributes;

    if (!isLoading && attributes) {
      privileged.includes(attributes.role) ? navigate('/admin') : navigate('/dashboard');
    }
  }, [isLoading, data, navigate]);

  if (isError) {
    return <AuthLinkError error={error} to="/" label="Request a new link" />;
  }

  return (
    <div>Logging in...</div>
  )
}
